// extracted by mini-css-extract-plugin
export var cardIcon = "_4e-4";
export var checkboxCard = "_4e-0";
export var checkboxCardSelected = "_4e-1";
export var disabled = "_4e-2";
export var outerBorder = "_4e-3";
export var spacerMedium = "_4e-7";
export var spacerSmall = "_4e-6";
export var spacerXsmall = "_4e-5";